const {hostname} = window.location;
const getEndpointProcedure = () => {
	if (hostname.includes('localhost')) return 'http://localhost:8081/';
	if (hostname.includes('bhp-inventarios.lifeon.cl')) return 'https://procedimientos.bhp.lifeon.cl/';
	return 'https://procedimientos.dev.bhp.lifeon.cl/';
}
export const ENDPOINT_PROCEDURE = getEndpointProcedure();
